// extracted by mini-css-extract-plugin
module.exports = {"suggest":"_6c97079b1b--suggest--1sY4r","suggest-item":"_6c97079b1b--suggest-item--3u0c5","suggest-error":"_6c97079b1b--suggest-error--2TacI"};